<template>
    <MobileTopBar :with_logo="true"/>
    <div class="container">
        <div class="mb-5 md:mb-10">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5 md:mb-8 items-stretch">
                <div class="group relative">
                    <HomeSlider/>
                </div>
                <div class="h-full md:aspect-[16/9]">
                    <HomeCategoryLinks class="h-full"/>
                </div>
            </div>
            <OnlyDesktop>
                <CompanyAdvantages/>
            </OnlyDesktop>
        </div>
        <div class="grid mb-10 gap-10">
            <div class="order-2 md:order-1">
                <PhotoBanner/>
            </div>
            <div class="order-1 md:order-2">
                <PopularBanners/>
            </div>
        </div>
        <!--        <div class="mb-5 md:mb-10">-->
        <!--            <ProductCategoriesLinks :categories="categories"/>-->
        <!--        </div>-->
        <div v-if="!themeStore.minimize_ui" class="mb-5 md:mb-10">
            <HomeAboutBlock/>
        </div>
    </div>
    <div v-if="!themeStore.minimize_ui" class="md:container max-md:ms-5 mb-5 md:mb-10">
        <PopularProducts/>
    </div>
    <div v-if="!themeStore.minimize_ui" class="container">
        <FaqComponent title="Частые вопросы о сдаче лома"
                      subtitle="Цены на металлолом, условия приёма, взвешивание, вывоз и порядок расчёта."
                      :items="homeFaqItems"
                      schema-id="schema-home-faq-jsonld"/>
    </div>
    <FastBuyCallback v-if="!themeStore.minimize_ui"/>
</template>

<script>
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import HomeSlider from "@js/components/Sections/PageComponent/Home/HomeSlider.vue";
import ProductCategoriesLinks from "@js/components/Sections/PageComponent/Home/ProductCategoriesLinks.vue";
import HomeAboutBlock from "@js/components/Sections/PageComponent/Home/HomeAboutBlock.vue";
import PopularProducts from "@js/components/Sections/Sliders/PopularProducts.vue";
import FaqComponent from "@js/components/Faq/FaqComponent.vue";
import FastBuyCallback from "@js/components/Callbacks/FastBuyCallback.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import CompanyAdvantages from "@js/components/Sections/PageComponent/Home/CompanyAdvantages.vue";
import HomeCategoryLinks from "@js/components/Sections/PageComponent/Home/Components/HomeCategoryLinks.vue";
import PopularBanners from "@js/components/Sections/PageComponent/Home/PopularBanners.vue";
import PhotoBanner from "@js/components/Sections/PageComponent/Home/PhotoBanner.vue";

export default {
    name: 'Home',
    props: {
        categories: {
            required: true,
        }
    },
    components: {
        PhotoBanner,
        PopularBanners,
        HomeCategoryLinks,
        CompanyAdvantages,
        FastBuyCallback,
        FaqComponent,
        PopularProducts,
        HomeAboutBlock,
        ProductCategoriesLinks,
        HomeSlider,
        MobileTopBar,
        OnlyDesktop,
    },
    data() {
        return {
            homeFaqItems: [
                {
                    title: 'Как узнать цену, по которой вы принимаете металлолом?',
                    text: `
        <p>Мы публикуем <strong>ориентировочные цены на металлолом</strong>, однако точная стоимость
        зависит от объёма, категории металла, степени засора и текущих биржевых котировок.</p>

        <p class="mt-2">Для расчёта позвоните нам или оставьте заявку на сайте.
        Специалист уточнит тип металла, объём, местоположение и необходимость демонтажа.
        После этого озвучим <strong>точную цену и сроки вывоза</strong>.</p>
        `
                },
                {
                    title: 'Где находится ближайший пункт приёма?',
                    text: `
        <p>Наши пункты приёма работают с частными лицами и предприятиями.
        Чтобы узнать ближайшую площадку, свяжитесь с менеджером —
        мы подскажем адрес и режим работы.</p>

        <p class="mt-2">Также доступна услуга <strong>выезда на объект</strong>,
        если у вас крупный объём металлолома.</p>
        `
                },
                {
                    title: 'Можно ли самостоятельно привезти металл?',
                    text: `
        <p>Да, вы можете самостоятельно привезти металлолом в пункт приёма.
        Рекомендуем предварительно связаться с менеджером для согласования условий,
        уточнения цены и часов работы.</p>

        <p class="mt-2">В некоторых случаях наш транспорт с погрузкой
        может быть выгоднее самостоятельной доставки.</p>
        `
                },
                {
                    title: 'Как происходит взвешивание и расчёт?',
                    text: `
        <p>Взвешивание проводится на <strong>поверенных электронных весах</strong>
        с возможностью видеофиксации.</p>

        <p class="mt-2">После определения фактического веса и процента засора
        производится расчёт по согласованной цене.
        Оплата осуществляется сразу — наличными или переводом на карту/расчётный счёт.</p>
        `
                },
                {
                    title: 'Что такое засор и как он влияет на цену?',
                    text: `
        <p><strong>Засор</strong> — это процент неметаллических примесей
        или включений других категорий металла.</p>

        <p class="mt-2">К засору относятся ржавчина, грязь, бетон, пластик,
        резина, краска, масло и другие примеси.
        Чем ниже засоренность — тем выше итоговая стоимость металлолома.</p>
        `
                },
                {
                    title: 'Работаете ли вы с юридическими лицами?',
                    text: `
        <p>Да, мы сотрудничаем с <strong>ООО и ИП</strong>.
        Предоставляем полный пакет документов, возможен безналичный расчёт и НДС.</p>

        <p class="mt-2">Для получения коммерческого предложения отправьте запрос
        на электронную почту или свяжитесь с менеджером —
        подготовим индивидуальные условия для вашего предприятия.</p>
        `
                }
            ]
        };
    },
    beforeMount() {
    },
    setup() {
        const themeStore = useThemeStore();
        return {themeStore}
    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
